import { motion } from 'framer-motion';
import { Scale, AlertCircle } from 'lucide-react';

export function TermosUso() {
  return (
    <div className="min-h-screen bg-gray-950 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-orange-500/10 flex items-center justify-center">
            <Scale className="w-8 h-8 text-orange-500" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Termos de Uso
          </h1>
          <p className="text-gray-400">
            Condições de uso do site e serviços Fort3D
          </p>
        </motion.div>

        {/* Content */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="prose prose-invert prose-orange max-w-none"
        >
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">1. Aceitação dos Termos</h2>
            <p className="text-gray-300 leading-relaxed">
              Ao acessar e utilizar o site da Fort3D, você concorda em cumprir estes Termos de Uso. 
              Se não concordar com qualquer parte destes termos, solicitamos que não utilize nosso 
              site e serviços. Estes termos constituem um acordo legal entre você e a 
              Fort3D Indústria e Comércio LTDA.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">2. Definições</h2>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li><strong>"Site"</strong> refere-se ao website fort3d.com.br e seus subdomínios;</li>
              <li><strong>"Usuário"</strong> refere-se a qualquer pessoa que acesse o site;</li>
              <li><strong>"Cliente"</strong> refere-se ao usuário que realiza uma compra;</li>
              <li><strong>"Conteúdo"</strong> inclui textos, imagens, vídeos, logotipos e materiais disponíveis no site.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">3. Uso do Site</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              Ao utilizar nosso site, você concorda em:
            </p>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>Fornecer informações verdadeiras, precisas e completas;</li>
              <li>Manter a confidencialidade de sua conta e senha;</li>
              <li>Ser responsável por todas as atividades em sua conta;</li>
              <li>Não usar o site para fins ilegais ou não autorizados;</li>
              <li>Não tentar acessar áreas restritas do site;</li>
              <li>Não interferir ou interromper o funcionamento do site.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">4. Propriedade Intelectual</h2>
            <p className="text-gray-300 leading-relaxed">
              Todo o conteúdo presente no site, incluindo mas não limitado a textos, gráficos, 
              logotipos, ícones, imagens, clipes de áudio, downloads digitais e software, 
              é propriedade da Fort3D ou de seus fornecedores de conteúdo e está protegido 
              pelas leis de direitos autorais brasileiras e internacionais.
            </p>
            <p className="text-gray-300 leading-relaxed mt-4">
              É proibida a reprodução, distribuição, modificação ou uso comercial de qualquer 
              conteúdo sem autorização expressa por escrito.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">5. Produtos e Serviços</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              Nos esforçamos para apresentar as informações dos produtos com a maior precisão 
              possível. No entanto:
            </p>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>As cores dos produtos podem variar conforme a configuração do monitor;</li>
              <li>As dimensões podem ter pequenas variações devido ao processo de impressão 3D;</li>
              <li>A disponibilidade de produtos está sujeita a estoque;</li>
              <li>Reservamo-nos o direito de modificar ou descontinuar produtos sem aviso prévio.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">6. Preços e Pagamentos</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              Os preços exibidos no site estão em Reais (R$) e incluem impostos conforme a 
              legislação brasileira. Aceitamos as seguintes formas de pagamento:
            </p>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>Cartão de Crédito (até 12x sem juros);</li>
              <li>PIX (5% de desconto);</li>
              <li>Boleto Bancário.</li>
            </ul>
            <p className="text-gray-300 leading-relaxed mt-4">
              Os preços podem ser alterados sem aviso prévio, mas os pedidos já confirmados 
              serão honrados ao valor original.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">7. Envio e Entrega</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              Os prazos de entrega são estimados e contam a partir da confirmação do pagamento. 
              Fatores que podem afetar o prazo:
            </p>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>Produtos sob encomenda requerem tempo de produção;</li>
              <li>Endereços de entrega em áreas remotas;</li>
              <li>Eventos de força maior (greves, desastres naturais, etc.);</li>
              <li>Problemas de logística dos transportadores.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">8. Trocas e Devoluções</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              Em conformidade com o Código de Defesa do Consumidor brasileiro:
            </p>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>
                <strong>Arrependimento:</strong> 7 dias após o recebimento para produtos prontos;
              </li>
              <li>
                <strong>Produtos com defeito:</strong> 30 dias para produtos não duráveis, 
                90 dias para produtos duráveis;
              </li>
              <li>
                <strong>Produtos personalizados:</strong> não são elegíveis para devolução 
                por arrependimento, apenas em caso de defeito.
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">9. Limitação de Responsabilidade</h2>
            <p className="text-gray-300 leading-relaxed">
              A Fort3D não será responsável por danos indiretos, incidentais, especiais ou 
              consequenciais resultantes do uso ou incapacidade de usar o site ou produtos. 
              Nossa responsabilidade total em qualquer circunstância não excederá o valor 
              pago pelo produto em questão.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">10. Links para Terceiros</h2>
            <p className="text-gray-300 leading-relaxed">
              Nosso site pode conter links para sites de terceiros. Não temos controle sobre 
              o conteúdo desses sites e não nos responsabilizamos por suas práticas de 
              privacidade ou termos de uso.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">11. Alterações nos Termos</h2>
            <p className="text-gray-300 leading-relaxed">
              Reservamo-nos o direito de modificar estes termos a qualquer momento. Alterações 
              entrarão em vigor imediatamente após a publicação no site. O uso continuado do 
              site após modificações constitui aceitação dos novos termos.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">12. Lei Aplicável</h2>
            <p className="text-gray-300 leading-relaxed">
              Estes termos são regidos pelas leis da República Federativa do Brasil. Quaisquer 
              disputas serão resolvidas nos tribunais da comarca de São Paulo/SP, com 
              renúncia a qualquer outro foro.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">13. Contato</h2>
            <p className="text-gray-300 leading-relaxed">
              Para questões sobre estes termos, entre em contato:
            </p>
            <div className="bg-gray-900 rounded-xl p-6 border border-white/5 mt-4">
              <p className="text-gray-300">
                <strong>Fort3D Indústria e Comércio LTDA</strong><br />
                CNPJ: 00.000.000/0000-00<br />
                E-mail: juridico@fort3d.com.br<br />
                Endereço: São Paulo, SP - Brasil
              </p>
            </div>
          </section>

          <div className="bg-orange-500/10 border border-orange-500/20 rounded-xl p-6 mt-12">
            <div className="flex items-start gap-4">
              <AlertCircle className="w-6 h-6 text-orange-500 flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="text-white font-semibold mb-2">Aviso Importante</h3>
                <p className="text-gray-300 text-sm">
                  Ao continuar navegando em nosso site, você declara que leu, entendeu e 
                  concorda com estes Termos de Uso. Para compras, será solicitada confirmação 
                  expressa de aceite.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
